import { formatBankAccount } from 'features/shared/helpers/Formatters';
import React from 'react';
import { useTranslation } from 'react-i18next';
import PaymentMethodDTO from '../dtos/PaymentMethodDTO';
import { PaymentMethodType } from '../enums/paymentMethodType';

interface Props {
  paymentMethod: PaymentMethodDTO;
}

const PaymentMethod = ({ paymentMethod }: Props) => {
  // tanslations
  const { t } = useTranslation(["payments\\enums\\paymentMethodType"]);

  // sub-renders
  const renderPaymentDetails  = () => {
    if (isBankAccountMethod(paymentMethod.paymentMethodType) && paymentMethod.bankAccount) {
      return <div className="font-weight-normal text-secondary mt-n1">{formatBankAccount(paymentMethod.bankAccount)}</div>
    } else if (paymentMethod.paymentMethodType === PaymentMethodType.Sipo && paymentMethod.sipoAccount) {
      return <div className="font-weight-normal mt-n1">{paymentMethod.sipoAccount.sipoNumber}</div>;
    }
  }

  // helpers
  const isBankAccountMethod = (paymentMethodType?: PaymentMethodType) => {
    let allowedMethods = [PaymentMethodType.BankTransfer, PaymentMethodType.PaymentOrder, PaymentMethodType.PaymentOrderDebit, PaymentMethodType.PaymentOrderKredit];
    return (paymentMethodType ? allowedMethods.includes(paymentMethodType) : false);
  }
  
  // render
  return (
    <>
      <div>{t(paymentMethod.paymentMethodType || "")}</div>
      {renderPaymentDetails()}
    </>
  )
}

export default PaymentMethod;
